import { useState, useRef } from "react";

const useProductFiltering = (products, categories) => {
  const [searchTerm, setSearchTerm] = useState("")
  const [selectedCategoryId, setSelectedCategoryId] = useState("")
  const categoryRefs = useRef({})

  const categoryProducts = (catId) => products.filter((p) => p.categoryId == catId)

  const filteredProducts = searchTerm
    ? products.filter(p => p.name.toLowerCase().includes(searchTerm.toLowerCase()))
    : products

  const scrollToCategory = (categoryId) => {
    if (categoryRefs.current[categoryId]) {
      categoryRefs.current[categoryId].scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
    setTimeout(() => setSelectedCategoryId(""), 100)
  }

  const activeCategories = categories.filter(category => {
    if (!category.active) return false
    const catProducts = categoryProducts(category.id)
    if (searchTerm) {
      return catProducts.some(p => filteredProducts.includes(p))
    }
    return catProducts.length > 0
  })

  return {
    searchTerm,
    setSearchTerm,
    selectedCategoryId,
    setSelectedCategoryId,
    categoryRefs,
    categoryProducts,
    filteredProducts,
    scrollToCategory,
    activeCategories
  }
}

export default useProductFiltering
